module.exports = __webpack_public_path__ + "static/media/message.232c9adf.svg";